import { render, staticRenderFns } from "./search-authority-editor.vue?vue&type=template&id=07c6ca34&scoped=true&"
import script from "./search-authority-editor.vue?vue&type=script&lang=js&"
export * from "./search-authority-editor.vue?vue&type=script&lang=js&"
import style0 from "./search-authority-editor.vue?vue&type=style&index=0&id=07c6ca34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c6ca34",
  null
  
)

export default component.exports